import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import styles from './style.cssmodule.css';

function Status({ status }) {
  const { formatMessage: t } = useIntl();
  let label;

  switch (status) {
    case 'ACTIVE':
      label = t({ id: 'account.status.active' });
      break;
    case 'INACTIVE':
      label = t({ id: 'account.status.inactive' });
      break;
    case 'ARCHIVED':
      label = t({ id: 'account.status.archived' });
      break;
    case 'PENDING_EMAIL_VALIDATION':
      label = t({ id: 'account.status.pending' });
      break;
    default:
      label = null;
  }

  return (
    <div className={styles.container} data-status={status}>
      {label}
    </div>
  );
}

Status.propTypes = {
  status: PropTypes.string,
};

Status.defaultProps = {
  status: null,
};

export default Status;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/Status/Status.jsx